import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { IAuthStore, IAuthedAdmin } from 'types';

const initialState: IAuthStore = {
  login: false,
  accessToken: '',
  user: undefined,
};

const {
  reducer,
  actions: { login, logout, setUser },
} = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      state.login = true;
      state.accessToken = action.payload;
      state.loginAt = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
    },
    logout: (state) => {
      state.login = false;
      state.loginAt = '';
      state.user = undefined;
    },
    setUser: (state, action: PayloadAction<IAuthedAdmin>) => {
      state.user = action.payload;
    },
  },
});

export { initialState, login, logout, setUser };
export default reducer;
